import React, { FC } from 'react';
import { AuthenticationContainer } from '@components/organisms/AuthenticationContainer';
import { TwoFactorAuthVerifyCard } from '@components/molecules/authentication/TwoFactorAuthVerifyCard';

export const TwoFactorAuthVerify: FC = () => {
    return (
        <AuthenticationContainer>
            <TwoFactorAuthVerifyCard />
        </AuthenticationContainer>
    );
};
